import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

export default function PairingQr({ code }: { code: string }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (!canvasRef.current || !code) return;
    void QRCode.toCanvas(canvasRef.current, `https://lagking.com/tv/pair/?code=${code}`, {
      width: 360,
      margin: 2,
      errorCorrectionLevel: 'M',
      color: { dark: '#071426', light: '#ffffff' },
    });
  }, [code]);
  return <canvas className="pair-qr" ref={canvasRef} aria-label="LagKing TV pairing QR code" />;
}
